var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "frame-visualisation",
      class: { border: _vm.sku == null && !_vm.backing },
    },
    [
      _c(
        "b-overlay",
        {
          attrs: { show: _vm.loading || _vm.frameErrors.length > 0 },
          scopedSlots: _vm._u(
            [
              _vm.frameErrors.length > 0
                ? {
                    key: "overlay",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-danger" },
                          _vm._l(_vm.frameErrors, function (error, idx) {
                            return _c("span", { key: idx }, [
                              _vm._v(_vm._s(error)),
                              _c("br"),
                            ])
                          }),
                          0
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _c(
            "b-carousel",
            {
              staticClass: "p-2",
              attrs: {
                controls: "",
                indicators: "",
                interval: _vm.slideInterval,
              },
              model: {
                value: _vm.slideIndex,
                callback: function ($$v) {
                  _vm.slideIndex = $$v
                },
                expression: "slideIndex",
              },
            },
            [
              !_vm.error
                ? _c("b-carousel-slide", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "img",
                          fn: function () {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-center p-2",
                                  staticStyle: { height: "100%" },
                                  attrs: { href: "#" },
                                  on: { click: _vm.openModal },
                                },
                                [
                                  _c("img", {
                                    ref: "viz",
                                    attrs: { id: "viz-image", src: _vm.url },
                                    on: {
                                      load: function ($event) {
                                        _vm.loading = false
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2985279988
                    ),
                  })
                : _c("b-carousel-slide", {
                    attrs: {
                      caption: "Unable to load frame visualisation",
                      "img-blank": "",
                    },
                  }),
              _vm.sku
                ? _c("b-carousel-slide", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "img",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  staticStyle: { height: "100%" },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      id: "chevron-image",
                                      src: _vm.chevronUrl,
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1647879494
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "image-viewer",
            "hide-footer": "",
            "hide-header": "",
            size: "xl",
            centered: "",
          },
        },
        [
          _c("b-button-close", { on: { click: _vm.closeModal } }),
          _c("div", { staticClass: "text-center p-3" }, [
            _c("img", {
              staticStyle: { "max-height": "80vh" },
              attrs: { src: _vm.url },
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }